module.exports = __webpack_public_path__ + "static/img/img19.5cba07d.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/neighbourhood/img19.png
// module id = MYQ4
// module chunks = 1